package org.vreo.devicehub.features.roi.presentation.components

import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.Path
import androidx.compose.ui.graphics.drawscope.DrawScope
import androidx.compose.ui.graphics.drawscope.Stroke
import androidx.compose.ui.text.TextMeasurer
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.drawText
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp


/**
 * Draw the ROI on canvas
 *
 * @param roiPoints ROI points to draw
 * @param draggingIndex selected point index, single ROI coordinate will be highlighted
 * @param label ROI label to draw
 * @param roiColor ROI color to draw
 */
fun DrawScope.drawRoi(
    roiPoints: List<Offset>,
    draggingIndex: Int,
    roiColor: Color,
    label: String,
    textMeasurer: TextMeasurer
) {
    // Inside DrawScope, scale points up to draw
    val points = roiPoints.map {
        Offset(it.x * size.width, it.y * size.height)
    }

    // Draw lines between points. This creates solid shape of the ROI.
    val path = Path().apply {
        if (points.isNotEmpty()) {
            moveTo(points[0].x, points[0].y)
            points.forEach { lineTo(it.x, it.y) }
            close()
        }
    }

    // Draw outline of the ROI
    drawPath(
        path = path,
        color = roiColor,
        style = Stroke(width = 3.dp.toPx())
    )

    // Fill the ROI
    drawPath(
        path = path,
        color = roiColor,
        alpha = 0.5f
    )

    // Draw circular points to indicate movable/draggable points
    points.forEachIndexed { pointIndex, point ->
        drawCircle(Color.White, radius = 10.dp.toPx(), center = point)
        drawCircle(
            color = if (draggingIndex == pointIndex) Color.Red else Color.Green,
            radius = 10.dp.toPx(),
            center = point,
            style = Stroke(width = 2.dp.toPx())
        )
    }

    // Draw lable
    if (label.isNotEmpty()) {
        val textLayoutResult = textMeasurer.measure(
            text = label,
            style = TextStyle(
                color = Color.White,
                fontSize = 12.sp,
                fontWeight = FontWeight.Bold,
                background = roiColor.copy(alpha = 0.7f)
            )
        )
        drawText(
            textLayoutResult = textLayoutResult,
            topLeft = Offset(
                x = points[0].x + 15.dp.toPx(),
                y = points[0].y - 25.dp.toPx()
            )
        )
    }
}
